import {useState} from 'react'
import {states, businesses} from "../data/BusinessType"
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'

const BusinessRegistration = () => {
    const [businessRegistrationData, setBusinessRegistrationData] = useState({
        name: "",
        owner: "",
        ic: "",
        dic: "",
        email: "",
        password: "",
        phone:"",
        businessType: "Kadeřnictví",
        street: "",
        city: "",
        postalCode: "",
        language: "cs",
        country: "Česko",
        termsAndConditions: false,
    })
    const [message, setMessage] = useState(null)
    const navigate = useNavigate()
    const DataChange = (e) => {
        const {name, value, type, checked} = e.target
        setBusinessRegistrationData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }))
    }

    const formSubmit = async (e) => {
        e.preventDefault()
        try {
            
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/business/register`, businessRegistrationData)
            setMessage(response?.data.message || "Registrace proběhla úspěšně")
            navigate("/business/profile")
        } catch (err) {
            setMessage(err.response?.data || err.message)
        } finally {
            setTimeout(() => {
                setMessage(null)
                navigate("/business/profile")
            }, 2000)
        }
    }
    const handleBusinessRegisteButtonClick = () => {
        window.gtag('event', 'click', {
          event_category: 'Button',
          event_action: 'Click',
          event_label: 'Registrace podniku',
        });
      };

  return (
    <div>
    <div >
    <h2 className="services-title">Registrace podniku samostatně</h2>
    <form className="login-form" onSubmit={formSubmit}>
        <input
            type="text"
            placeholder="Jméno podniku"
            name="name"
            value={businessRegistrationData.name}
            onChange={DataChange}
            required
            className="login-input registration-input-width"
        />   
        <select
        id="businessType"
        name="businessType"
        value={businessRegistrationData.businessType}
        onChange={DataChange}
        required
        className="login-input registration-input-width"
        >
        {businesses.map((response, index) => (
            <option key={index} value={response}>
                {response}
            </option>
        ))}
    </select>
        <input
            type="text"
            placeholder="Jméno a příjmení"
            name="owner"
            value={businessRegistrationData.owner}
            onChange={DataChange}
            required
            className="login-input registration-input-width"
        />
        <input
            type="text"
            placeholder="IČ (nepovinné)"
            name="ic"
            value={businessRegistrationData.ic}
            onChange={DataChange}
            className="login-input registration-input-width"
        />
        <input
            type="text"
            placeholder="DIČ (nepovinné)"
            name="dic"
            value={businessRegistrationData.dic}
            onChange={DataChange}
            className="login-input registration-input-width"
        />
        <input
            type="email"
            placeholder="Email"
            name="email"
            value={businessRegistrationData.email}
            onChange={DataChange}
            required
            className="login-input registration-input-width"
        />
        <input
            type="password"
            placeholder="Heslo"
            name="password"
            value={businessRegistrationData.password}
            onChange={DataChange}
            required
            className="login-input registration-input-width"
        />
        <input
            type="text"
            placeholder="Telefonní číslo"
            name="phone"
            value={businessRegistrationData.phone}
            onChange={DataChange}
            required
            className="login-input registration-input-width"
        />



            <input
                type="text"
                placeholder="Město"
                id="city"
                name="city"
                value={businessRegistrationData.city}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />



            <input
                type="text"
                placeholder="Ulice"
                id="street"
                name="street"
                value={businessRegistrationData.street}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />



            <input
                type="text"
                placeholder="Číslo popisné"
                id="houseNumber"
                name="houseNumber"
                value={businessRegistrationData.houseNumber}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />


            <input
                type="text"
                placeholder="PSČ"
                id="postalCode"
                name="postalCode"
                value={businessRegistrationData.postalCode}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />



            <select
                id="country"
                name="country"
                value={businessRegistrationData.country}
                onChange={DataChange}
                required
                className="login-input registration-input-width"
            >
                {states.map((state, index) => (
                    <option key={index} value={state.name}>
                        {state.name}
                    </option>
                ))}
            </select>

        <div className='gdpr'>
    <p >Souhlasím s podmínky používání</p>
  <input 
    type='checkbox'
    name='termsAndConditions'
    value={businessRegistrationData.termsAndConditions}
    onChange={DataChange}
    className='business-registration-terms'
    required
  />
  </div>
        <button type="submit" className="login-button" onClick={handleBusinessRegisteButtonClick}>
            Registrovat se
        </button>
    </form>
    <div className="login-links">
        <Link to="/termsAndConditions" className="login-link">Podmínky používání a cookies</Link>
        <Link to="/termsAndConditions" className="login-link">Zásady ochrany osobních údajů</Link>

    </div>
{message && <p className="message">{message}</p>}
</div>
</div>
  )
}

export default BusinessRegistration